import { useCallback } from 'react';

export const useOnboardingStep = ({
  searchParams,
  setSearchParams,
}: {
  searchParams: URLSearchParams;
  setSearchParams: (params: (prev: URLSearchParams) => URLSearchParams) => void;
}) => {
  const step = searchParams.get('step')
    ? parseInt(searchParams.get('step') ?? '0')
    : 0;

  const setStep = useCallback(
    (newStep: number) => {
      setSearchParams((prev) => {
        prev.set('step', newStep.toString());
        return prev;
      });
    },
    [setSearchParams]
  );

  return { step, setStep };
};
